import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=17175f63&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=17175f63&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17175f63",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17175f63')) {
      api.createRecord('17175f63', component.options)
    } else {
      api.reload('17175f63', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=17175f63&scoped=true", function () {
      api.rerender('17175f63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/vocational-evaluation/tabs/five/instrument/VALPARSystemSample/Main.vue"
export default component.exports